import './App.css';

const services = [
  {
    title: 'Service Provision',
    description: 'Nous offrons des services adaptés aux besoins de nos membres et partenaires.',
    icon: '🛠️',
  },
  {
    title: 'Advertising and Marketing',
    description: 'Nous aidons à promouvoir vos activités et à atteindre votre public cible.',
    icon: '📢',
  },
  {
    title: 'Information Technology and Communication',
    description: 'Nous proposons des solutions IT et des services de communication innovants.',
    icon: '💻',
  },
  {
    title: 'General Trade',
    description: 'Nous facilitons les échanges commerciaux entre nos membres.',
    icon: '🛒',
  },
];

function App() {
  return (
    <div className="App">
      <nav className="main-nav">
        <a href="#home" className="logo">
          <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="ABS Logo" className="logo-img" />
        </a>
        <div className="nav-links">
          <a href="#home">Accueil</a>
          <a href="#about">À propos</a>
          <a href="#services">Nos Services</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>
      <header className="App-header" id="home">
        <div className="header-logo">
          <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="ABS Logo" className="main-logo" />
        </div>
        <h1>Bienvenue sur le site de Africa Business Support (ABS)</h1>
        <p style={{ maxWidth: 600, margin: '0 auto' }}>
          Africa Business Support (ABS) fournit des services variés pour accompagner ses membres dans leur développement et leur réussite.
        </p>
      </header>
      <section className="about-section" id="about">
        <h2>À propos de Africa Business Support (ABS)</h2>
        <p style={{ maxWidth: 700, margin: '0 auto' }}>
          Africa Business Support (ABS) est une organisation dédiée à l'accompagnement de ses membres dans divers domaines : services, marketing, technologies de l'information et commerce général. Notre mission est de favoriser le développement, l'innovation et la réussite de nos membres à travers des services adaptés et un réseau dynamique.
        </p>
      </section>
      <section className="services-section" id="services">
        <h2>Nos Services</h2>
        <div className="services-list">
          {services.map((service) => (
            <div className="service-card" key={service.title}>
              <span className="service-icon" aria-label={service.title}>{service.icon}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="contact-section" id="contact">
        <h2>Contact</h2>
        <form className="contact-form" onSubmit={e => { e.preventDefault(); alert('Message envoyé !'); }}>
          <input type="text" placeholder="Votre nom" required />
          <input type="email" placeholder="Votre email" required />
          <textarea placeholder="Votre message" required rows={4}></textarea>
          <button type="submit">Envoyer</button>
        </form>
      </section>
      <footer className="main-footer">
        <div className="footer-content">
          <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="ABS Logo" className="footer-logo" />
          <p>&copy; {new Date().getFullYear()} Africa Business Support (ABS). Tous droits réservés.</p>
          <p><a href="/politique-de-confidentialite_">Politique de confidentialité</a></p>
        </div>
      </footer>
    </div>
  );
}

export default App;
